import { Routes, Route } from "react-router";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

//Views
import KeyFobsMain from "Modules/keysFobs/views/main";

const RouterKeyFobs = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "kfb") && <Route path="list" element={<KeyFobsMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterKeyFobs;